import React from 'react'
import { TrustPilotWidget } from './TrustPilotWidget'
import { GoogleReviewWidget } from './GoogleReviewWidget'

const ReviewWidget = ({
  reviewsConfiguration = {},
  orientation = 'horizontal',
  color = 'black',
}: {
  reviewsConfiguration: any
  orientation?: 'horizontal' | 'vertical'
  color?: 'black' | 'white'
}): JSX.Element => {
  const isVertical = orientation === 'vertical'
  const textColor = color === 'white' ? 'text-gray-200' : 'text-gray-500'

  return (
    <div className='flex flex-col items-center mt-3'>
      {/* <p className={`mt text-center text-xs font-bold mb-1`}>
        🚀 600+ reviews in {new Date().getFullYear()}
      </p> */}
      <div
        className={`flex ${
          isVertical ? 'flex-col' : 'sm:flex-row'
        } px-0 sm:px-20 ${
          isVertical
            ? 'items-start gap-4'
            : 'flex-col sm:flex-row justify-center items-center gap-4'
        }`}
      >
        <TrustPilotWidget
          widgetConfig={reviewsConfiguration.reviewBadges?.trustpilot}
        />
        <GoogleReviewWidget
          widgetConfig={reviewsConfiguration.reviewBadges?.google}
          color={color}
        />
      </div>
    </div>
  )
}

export default ReviewWidget
